const PERMISSIONS_DESCRIPTIONS = {
  CLAIM: {
    title: 'Access Claim',
    subtitle: 'View claim details',
    description: '',
  },
  CREATE_LIKE_CLAIM: {
    title: 'Create Like Claim',
    subtitle: 'Re-create a claim as a new claim under a different LOB / sub-organization',
    description:
      'Allows re-creating a claim as a brand-new claim under a different LOB / sub-organization via the FNOL screen, with the original and new claims cross-linked.',
    default_verb: 'FORBIDDEN',
  },
  RECOVERY_REQUEST: {
    title: 'Recovery Request',
    subtitle: 'Request a recovery payment from a payer, and cancel a request',
    description:
      'Allows asking a payer to send money back on a claim and withdrawing a request that has not settled. Recording the money once it arrives is a general recovery and stays under the existing recovery permissions.',
    default_verb: 'FORBIDDEN',
  },
  DATE_OF_LOSS: {
    title: 'Date of Loss',
    subtitle: 'Edit the incident date of loss ',
    description: '',
  },
  TIME_OF_LOSS: {
    title: 'Time of Loss',
    subtitle: 'Edit the incident time of loss ',
    description: '',
  },
  DATE_OF_REPORT: {
    title: 'Date of Report',
    subtitle: 'Edit the claim report date ',
    description: '',
  },
  REPORTER: {
    title: 'Reporter',
    subtitle: 'Edit the claim Reporter',
    description: '',
    default_verb: 'READ',
  },
  EXTERNAL_CLAIM_NUMBER: {
    title: 'External Claim Number',
    subtitle: 'Set/Edit the external claim numbers',
    description: '',
  },
  COVERAGE_DECISION: {
    title: 'Coverage Decision',
    subtitle: 'Set/Edit the coverage decision',
    description: '',
  },
  NOTE: {
    title: 'Notes',
    subtitle: 'View, create, delete, and set notes as confidential.',
    description: '',
  },
  NOTIFICATION: {
    title: 'Notifications',
    subtitle: 'View and create notifications',
    description: '',
  },
  CHANGE_CLAIM_OWNER: {
    title: 'Change file owner',
    subtitle: 'Select a new file owner',
    description: '',
  },
  CHANGE_EXPOSURE_OWNER: {
    title: 'Change exposure owner',
    subtitle: 'Select a new exposure owner',
    description: '',
  },
  EXPORT_CLAIM: {
    title: 'Export Claim',
    subtitle: 'Export claim to PDF',
    description: '',
  },
  LEGAL_ACTIONS: {
    title: 'Legal Actions Tab',
    subtitle: 'View and Edit Legal Actions',
    description: '',
  },
  INDEMNITY_RESERVE: {
    title: 'Set Indemnity Reserve',
    subtitle: 'Set and edit the indemnity reserve',
    description: '',
  },
  EXPENSES_RESERVE: {
    title: 'Set Expenses Reserve',
    subtitle: 'Set and edit the expenses reserve',
    description: '',
  },
  GENERAL_EXPENSES_RESERVE: {
    title: 'Set General Expenses Reserve',
    subtitle: 'Set and edit the general expenses reserve',
    description: '',
  },
  INDEMNITY_PAYMENT: {
    title: 'Issue Indemnity Payments',
    subtitle: 'Issue indemnity payments',
    description: '',
  },
  EXPENSES_PAYMENT: {
    title: 'Issue Expenses Payments',
    subtitle: 'Issue expenses payments',
    description: '',
  },
  GENERAL_EXPENSES_PAYMENT: {
    title: 'Issue General Expenses Payments',
    subtitle: 'Issue general expenses payments',
    description: '',
  },
  CANCEL_INDEMNITY_PAYMENT: {
    title: 'Cancel Indemnity Payments',
    subtitle: 'Cancel indemnity payments',
    description: '',
  },
  CANCEL_EXPENSES_PAYMENT: {
    title: 'Cancel Expenses Payments',
    subtitle: 'Cancel expenses payments',
    description: '',
  },
  CANCEL_GENERAL_EXPENSES_PAYMENT: {
    title: 'Cancel General Expenses Payments',
    subtitle: 'Cancel general expenses payments',
    description: '',
  },
  OFAC_OVERRIDE: {
    title: 'Approve Sanction lists',
    subtitle: 'Approve payments after sanction lists hit',
    description: '',
  },
  APPROVE_INDEMNITY_PAYMENT_OVER_LIMIT: {
    title: 'Approve indemnity payment over limit',
    subtitle: 'Allow approve indemnity payment over policy limit',
    description: '',
  },
  APPROVE_CHANGE_INDEMNITY_RESERVE_OVER_LIMIT: {
    title: 'Approve indemnity reserve over limit',
    subtitle: 'Allow approve indemnity reserve over policy limit',
    description: '',
  },
  CLAIM_DOCUMENT: {
    title: 'Documents tab',
    subtitle: 'Add new documents, view, edit and delete existing documents',
    description: '',
  },
  MANUAL_POLICY: {
    title: 'Manual Policy',
    subtitle: 'Edit manual policy',
    description: '',
  },
  API_POLICY: {
    title: 'API Policy',
    subtitle: 'Edit API policy',
    description: '',
  },
  MOI: {
    title: 'MOI',
    subtitle: 'View and edit MOI',
    description: '',
  },
  CONTACT: {
    title: 'Contacts and parties',
    subtitle: 'View and edit contacts and party cards',
    description: '',
  },
  CONTACT_PII: {
    title: 'Contact PII',
    subtitle: 'View and edit contact PII',
    description: '',
  },
  CONTACT_FINANCE_PII: {
    title: 'Contact Finance PII',
    subtitle: 'View and edit contact finance PII',
    description: '',
  },
  W9_TIN: {
    title: 'W9_TIN',
    subtitle: "Upload a contact's W9 and view and edit TIN",
    description: '',
  },
  CONTACT_FINANCE_APPROVER: {
    title: 'Contact Finance Approver',
    subtitle: 'Approve financial detail changes',
    description: 'Allows approving contact financial detail changes when verification is required',
    default_verb: 'READ',
  },
  TRUSTED_PAYEE_ARRANGEMENT: {
    title: 'Trusted Payee Arrangement',
    subtitle: 'Mark contacts as pre-approved payees',
    description:
      'Allows marking a contact as a pre-approved (trusted) payee with an optional valid-to date and per-payment limit',
    default_verb: 'READ',
  },
  CONTACT_TFN_APPROVER: {
    title: 'Contact TFN Approver',
    subtitle: 'Approve TFN declaration changes',
    description: 'Allows approving contact TFN declaration changes when verification is required',
    default_verb: 'READ',
  },
  DEACTIVATE_CONTACT: {
    title: 'Deactivate Contact',
    subtitle: 'Deactivate contacts from the organization',
    description: 'Allows deactivating contacts with a reason and optional reference contact',
    default_verb: 'FORBIDDEN',
  },
  CREATE_FNOL: {
    title: 'Create FNOL',
    subtitle: 'Create a new FNOL',
    description: '',
  },
  QA: {
    title: 'QA',
    subtitle: 'View QA results and run QA on selected claims',
    description: '',
  },
  GENERAL_EMAIL_CLASSIFICATION: {
    title: 'General Email Classification',
    subtitle: 'Classify and attach incoming emails to claims',
    description: '',
  },
  REPORT: {
    title: 'View reports and dashboards',
    subtitle: 'View reports and dashboards',
    description: '',
  },
  ADJUSTER_DASHBOARD: {
    title: 'View Adjuster Suite',
    subtitle: 'View the reports and dashboards adjuster suite',
    description: '',
  },
  MANAGEMENT_REPORTS_AND_DASHBOARDS: {
    title: 'View Management Suite',
    subtitle: 'View the reports and dashboard management suite',
    description: '',
  },
  VIEW_GENERAL_REPORTS_SUITE: {
    title: 'View General Suite',
    subtitle: 'View general reports and dashboards',
    description: '',
  },
  CREATE_REPORTS_AND_DASHBOARDS: {
    title: 'Create Reports and Dashboards',
    subtitle: 'Create reports and dashboards and share them with your organization',
    description: '',
  },
  SYSTEM_CONFIGURATION: {
    title: 'System configurations',
    subtitle: ' View and edit system configurations',
    description: '',
  },
  SYSCONFIG_USER_MANAGEMENT: {
    title: 'User Management',
    subtitle: 'Settings and configuration related to organization users',
    description: 'Settings and configuration related to organization users',
    default_verb: 'FORBIDDEN',
  },
  SYSCONFIG_ADJUSTER_MANAGEMENT: {
    title: 'Adjuster Management',
    subtitle: 'Settings and configuration related to adjusters',
    description: 'Settings and configuration related to adjusters',
    default_verb: 'FORBIDDEN',
  },
  SYSCONFIG_AUTOMATION: {
    title: 'Automatic Rules',
    subtitle: 'Settings and configuration related to automatic rules',
    description: 'Settings and configuration related to automatic rules',
    default_verb: 'FORBIDDEN',
  },
  SYSCONFIG_COMMUNICATIONS: {
    title: 'Communication Configuration',
    subtitle: 'Settings and configuration related to communication',
    description: 'Settings and configuration related to communication',
    default_verb: 'FORBIDDEN',
  },
  SYSCONFIG_NOTIFICATIONS: {
    title: 'Notifications Configuration',
    subtitle: 'Settings and configuration related to notifications',
    description: 'Settings and configuration related to notifications',
    default_verb: 'FORBIDDEN',
  },
  SYSCONFIG_CLAIM_CONFIG: {
    title: 'Claim Configuration',
    subtitle: 'Settings and configuration related to claims',
    description: 'Settings and configuration related to claims',
    default_verb: 'FORBIDDEN',
  },
  SYSCONFIG_CONTACT: {
    title: 'Contact Roles',
    subtitle: 'Settings and configuration related to contacts and contact roles',
    description: 'Settings and configuration related to contacts and contact roles',
    default_verb: 'FORBIDDEN',
  },
  SYSCONFIG_POLICY_FNOL: {
    title: 'Policy & FNOL Configuration',
    subtitle: 'Settings and configuration related to policies and FNOL',
    description: 'Settings and configuration related to policies and FNOL',
    default_verb: 'FORBIDDEN',
  },
  SYSCONFIG_TEMPLATES: {
    title: 'Templates',
    subtitle: 'Settings and configuration related to templates and documents',
    description: 'Settings and configuration related to templates and documents',
    default_verb: 'FORBIDDEN',
  },
  SYSCONFIG_RESERVES: {
    title: 'Reserve Configuration',
    subtitle: 'Settings and configuration related to reserves and payments',
    description: 'Settings and configuration related to reserves and payments',
    default_verb: 'FORBIDDEN',
  },
  SYSCONFIG_DATA_REPORTING: {
    title: 'Data & Reporting',
    subtitle: 'Settings and configuration related to data exports and reporting',
    description: 'Settings and configuration related to data exports and reporting',
    default_verb: 'FORBIDDEN',
  },
  SYSCONFIG_LOGIN: {
    title: 'Login Configuration',
    subtitle: 'Settings and configuration related to login and authentication',
    description: 'Settings and configuration related to login and authentication',
    default_verb: 'FORBIDDEN',
  },
  SYSCONFIG_SUB_ORGANIZATIONS: {
    title: 'Sub Organizations',
    subtitle: 'Settings and configuration related to sub organizations',
    description: 'Settings and configuration related to sub organizations',
    default_verb: 'FORBIDDEN',
  },
  SYSCONFIG_LOCATIONS: {
    title: 'Supported Locations',
    subtitle: 'Settings and configuration related to supported locations',
    description: 'Settings and configuration related to supported locations',
    default_verb: 'FORBIDDEN',
  },
  SYSCONFIG_CAT_EVENTS: {
    title: 'Catastrophic Events',
    subtitle: 'Settings and configuration related to catastrophic events',
    description: 'Settings and configuration related to catastrophic events',
    default_verb: 'FORBIDDEN',
  },
  SYSCONFIG_PERMISSIONS: {
    title: 'Permission Profiles',
    subtitle: "Settings and configuration related to permission profiles, including a user's own permissions",
    description: "Settings and configuration related to permission profiles, including a user's own permissions",
    default_verb: 'FORBIDDEN',
  },
  SYSCONFIG_INTEGRATIONS: {
    title: 'Integrations',
    subtitle: 'Settings and configuration related to third-party integrations',
    description: 'Settings and configuration related to third-party integrations',
    default_verb: 'FORBIDDEN',
  },
  SYSCONFIG_DELEGATED_AUTHORITY: {
    title: 'Delegated Authority',
    subtitle: 'Settings and configuration related to delegated authority',
    description: 'Settings and configuration related to delegated authority',
    default_verb: 'FORBIDDEN',
  },
  SYSCONFIG_PERFORMANCE_QA: {
    title: 'Performance QA Builder',
    subtitle: 'Settings and configuration related to performance QA',
    description: 'Settings and configuration related to performance QA',
    default_verb: 'FORBIDDEN',
  },
  SYSCONFIG_CONFIG_MANAGEMENT: {
    title: 'Configuration Management',
    subtitle: 'Settings and configuration related to configuration management',
    description: 'Settings and configuration related to configuration management',
    default_verb: 'FORBIDDEN',
  },
  SYSCONFIG_CHAT_SUGGESTIONS: {
    title: 'Chat Suggestions',
    subtitle: 'Settings and configuration related to the predefined prompts offered in the Clive chat',
    description: 'Settings and configuration related to the predefined prompts offered in the Clive chat',
    default_verb: 'FORBIDDEN',
  },
  SYSCONFIG_SYSTEM_OF_RECORD: {
    title: 'System of Record',
    subtitle: "Settings and configuration related to the organization's external System of Record",
    description: "Settings and configuration related to the organization's external System of Record",
    default_verb: 'FORBIDDEN',
  },
  SYSCONFIG_GLOBAL_FIELDS: {
    title: 'Global Configuration',
    subtitle: 'Settings and configuration related to organization-wide policy and FNOL fields',
    description: 'Settings and configuration related to organization-wide policy and FNOL fields',
    default_verb: 'FORBIDDEN',
  },
  SOR_ISSUES_MANAGE: {
    title: 'System of Record Issues',
    subtitle: 'View and resolve the changes the System of Record has not confirmed',
    description:
      "Read lists the changes sent to the organization's System of Record and what became of each. Write also resolves a change CMS stopped checking with the System of Record, as made there or not, and starts a check of the open changes. Separate from the System of Record configuration, which Integrations governs.",
    default_verb: 'FORBIDDEN',
  },
  CLIVE: {
    title: 'Clive',
    subtitle: 'Control Clive usage',
    description: '',
  },
  CLIVE_CHAT: {
    title: 'Clive Chat',
    subtitle: 'Clive Chat Access',
    description: '',
  },
  CLIVE_CLAIM_SUMMARY: {
    title: 'Clive Claim Summary',
    subtitle: 'Clive Claim Summary Access',
    description: '',
  },
  CLIVE_CLAIM_INSIGHTS: {
    title: 'Clive Claim Insights',
    subtitle: 'Clive Claim Insights Access',
    description:
      "Allows viewing Clive's AI-generated insights for a claim. Without it, claim insights are neither fetched nor displayed.",
  },
  OVERRIDE_DEPRECIATION_CALCULATIONS: {
    title: 'Override Depreciation Calculations',
    subtitle: 'Override automatic depreciation calculations',
    description: '',
  },
  UNLINK_CLAIM_CONTACTS: {
    title: 'Unlink Claim Contacts',
    subtitle: 'Unlink contacts from claims',
    description: 'Allows unlinking contacts from claims. Does not delete the contact record.',
    default_verb: 'FORBIDDEN',
  },
  DELETE_INVOLVED_PARTY: {
    title: 'Delete Involved Party',
    subtitle: 'Delete drivers, passengers, vehicles, properties and non-motorists from a claim',
    description:
      'Allows removing involved parties from a claim. Deletion is blocked when the party is referenced by an exposure, recovery, or other significant record. Each deletion is recorded in the audit log and on the claim timeline.',
    default_verb: 'FORBIDDEN',
  },
} as const;

export default PERMISSIONS_DESCRIPTIONS;
